import { usePurchasePagePersonalQuery } from '@haaretz/s-pp-queries/PurchasePage';
import usePpDataVariables from '@haaretz/s-use-pp-data-variables';
import { useRouter } from 'next/router';
import React from 'react';
export default function usePpAbTest() {
    const router = useRouter();
    const abTestParam = router.query.forceAbTest;
    const excludedVariables = React.useMemo(()=>[
            'selectedOfferId'
        ], []);
    const variables = usePpDataVariables(excludedVariables);
    const { data } = usePurchasePagePersonalQuery(variables, {
        enabled: false
    });
    // NOTE: This is used only for testing purposes
    if (abTestParam && typeof abTestParam === 'string') {
        try {
            const decodedAbTest = atob(abTestParam);
            return JSON.parse(decodedAbTest);
        } catch (e) {
            console.error(e);
        }
    }
    return data?.PurchasePage?.pageData?.abTest;
}

//# sourceMappingURL=usePpAbTest.js.map